import React from 'react';
import withIcon from '../utilities/withIcon';

const IconLogoPinterest = () => {
  return (
    <g>
      <path d="m8 .16a7.84 7.84 0 0 0 -3.147 15.0206 6.8852 6.8852 0 0 1 .1365-1.8c.1507-.6365 1.0088-4.2719 1.0088-4.2719a3.0115 3.0115 0 0 1 -.25-1.24c0-1.1618.6734-2.0295 1.512-2.0295a1.05 1.05 0 0 1 1.0576 1.177 16.8753 16.8753 0 0 1 -.6929 2.7815 1.2134 1.2134 0 0 0 1.2374 1.51c1.4854 0 2.4858-1.9078 2.4858-4.1682a2.9349 2.9349 0 0 0 -3.2622-3.0044 3.7124 3.7124 0 0 0 -3.8597 3.7549 2.2633 2.2633 0 0 0 .5168 1.5377.38.38 0 0 1 .1127.437c-.0376.1443-.124.4915-.16.6292a.27.27 0 0 1 -.3925.1962 3.0194 3.0194 0 0 1 -1.6052-2.9957c0-2.227 1.8783-4.8975 5.6031-4.8975a4.6858 4.6858 0 0 1 4.9632 4.491c0 3.0754-1.71 5.3731-4.23 5.3731a2.2482 2.2482 0 0 1 -1.9153-.9772s-.4553 1.8062-.5517 2.1552a6.5628 6.5628 0 0 1 -.7891 1.6795 7.84 7.84 0 1 0 2.2217-15.3585z" />
    </g>
  );
};

export default withIcon(IconLogoPinterest);
